export default "__VITE_ASSET__B25kO5Sg__"